import "./App.css";
import BottomBar from "./components/layout/BottomBar";
import Footer from "./components/layout/Footer";
import Header from "./components/layout/Header";
import ContactSection from "./components/sections/ContactSection";
import FaqSection from "./components/sections/FaqSection";
import HeroSection from "./components/sections/HeroSection";
import ProcessSection from "./components/sections/ProcessSection";
import PromiseSection from "./components/sections/PromiseSection";
import RecruitSection from "./components/sections/RecruitSection";
import ReviewsSection from "./components/sections/ReviewsSection";
import ServicesSection from "./components/sections/ServicesSection";
import WhySection from "./components/sections/WhySection";
import useScrollReveal from "./hooks/useScrollReveal";

function App() {
  useScrollReveal();

  return (
    <div className="site-shell">
      <Header />
      <main>
        <HeroSection />
        <WhySection />
        <PromiseSection />
        <ServicesSection />
        <ProcessSection />
        <ReviewsSection />
        <FaqSection />
        <RecruitSection />
        <ContactSection />
      </main>
      <Footer />
      <BottomBar />
    </div>
  );
}

export default App;
